<template>
  <div>
    <transition name="fade">
      <div :class="{ 'ws-pre-wrap': pre }" class="text-box" :style="textBoxStyle" ref="text-box">
        <span ref="text" v-html="$xss(content)"></span>
      </div>
    </transition>
    <div v-if="showMoreBtn" class="launch" @click="onClickLaunch()">
      <div>{{ $t("common.launch") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pre: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    maxLine: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      showMoreBtn: false,
      textBoxStyle: {
        height: 'auto',
        '-webkit-line-clamp': 'auto'
      },
      lineHeight: 0,
      lineLenght: 0
    }
  },
  mounted() {
    const textBox = this.$refs['text-box'];
    this.lineHeight = this.getLineHeight(textBox);
    this.lineLenght = textBox.offsetHeight / this.lineHeight;
    console.log(this.lineHeight, this.lineLenght)
    if (this.lineLenght > this.maxLine) {
      this.showMoreBtn = true;
      this.textBoxStyle.height = this.maxLine * this.lineHeight + 'px';
      this.textBoxStyle['-webkit-line-clamp'] = this.maxLine;
    }
  },
  methods: {
    getLineHeight(element) {
      const style = window.getComputedStyle(element);
      const lineHeight = style.getPropertyValue('line-height');
      return parseFloat(lineHeight);
    },
    onClickLaunch() {
      this.showMoreBtn = false;
      this.textBoxStyle.height = this.lineLenght * this.lineHeight + 'px';
      this.textBoxStyle['-webkit-line-clamp'] = this.lineLenght;
    }
  }
}
</script>

<style lang="scss" scoped>
.text-box {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.launch {
  color: #617feb;
  cursor: pointer;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/more-text.vue